// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/header-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .login { /* border: 2px solid #367e3e; color: #047e35; */
/* border-radius: 10px; */
.header {
  opacity: 1;
  transition: opacity ease-in;
}

.hidden {
  opacity: 0;
  transform: opacity 0.3s ease-out;
}

.joinforbtn {
  background-color: #158b86;
  display: inline;
  margin-left: 10px;
  color: #ffffff;
}

.joinforbtn:hover {
  background-color: #16918a;
  display: inline;
  margin-left: 10px;
  color: #ffffff;
}

.companylogo {
  cursor: pointer;
  margin-left: 10px;
}

.header-container {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.header-container h1 {
  font-weight: 700;
  text-align: center;
  font-size: 3rem;
}

.secondheaders {
  background-color: #ffffff;
  /* position: fixed; */
  top: 73px;
  width: 100%;
  z-index: 101;
}

.firstheader {
  margin-left: 25px;
  height: 15px;
  width: 22px;
  border: 1px solid #000000;
  border-radius: 3px;
  display: inline;
}

.lastcon {
  float: right;
  margin-right: 10px;
}

.dropdown-toggle::after {
  color: #000000;
}

.nav-item .dropdown-menu {
  background: #e3f8e7;
}

.nav-item .dropdown-item {
  color: #000000;
}

.nav-item .dropdown-item:hover {
  background: #f0ad4e;
  color: #ffffff;
}

.activate {
  border-bottom: 2px solid green;
}

.nav-links {
  transition: 0.3s;
  margin-top: 2px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  font-family: "Josefin Sans",
    cursive;
}

.nav-links:hover {
  border-bottom: 2px solid green;
}

.nav-links:focus {
  border-bottom: 2px solid green;
}

.nav-links2 {
  transition: 0.3s;
  margin-top: 2px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}

.nav-links2:hover {
  border-bottom: 2px solid green;
}

.nav-links2:focus {
  border-bottom: 2px solid green;
}

.nav-links4 {
  transition: 0.3s;
  margin-top: 2px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #0f6863;
}

.nav-links4:hover {
  color: #0f6863;
  border-bottom: 2px solid #076460;
}

.nav-links4:focus {
  color: #0f6863;
  border-bottom: 2px solid #076460;
}

.nav-links23 {
  transition: 0.3s;
  margin-top: -5px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  /* margin-left: 5px; margin-right: 5px; */
}

.nav-links23:hover {
  border-bottom: 2px solid green;
}

.nav-links23:focus {
  border-bottom: 2px solid green;
}

.nav-links3 {
  transition: 0.3s;
  margin-top: 10px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}

.navbar_toggle_icon {
  background-color: darkgreen;
  color: red;
}

.socialmed {
  color: #0c572b;
}

.socialmed2 {
  color: #0c572b;
  cursor: pointer;
}

.showprofilebox {
  display: block;
}

.hideprofilebox {
  display: none;
}

.coursesNav {
  margin-top: 7%;
}

.coursescolorbox {
  margin-top: 7px;
  right: 30%;
  position: absolute;
  z-index: 77;
  width: 900px;
  /* max-width: 90vw; */
  /* height: 500px; */
  background-color: #e3f8e7;
  /* border: 1px solid #95beb5; */
  border-radius: 10px;
}

.dropdown-menu {
  background: #f2ffd8;
}

.servicesColorbox {
  margin-top: 7px;
  left: 10%;
  /* right: 0%; */
  position: absolute;
  z-index: 77;
  width: 250px;
  /* height: 500px; */
  background-color: #e3f8e7;
  /* border: 1px solid #95beb5; */
  border-radius: 10px;
}

.coursetttab {
  margin: 10px;
  padding: 10px;
  overflow-y: auto;
  height: 470px;
  /* border: 1px solid #95beb5; */
}

.servicestttab {
  /* margin: 10px; */
  /* padding: 10px; */
  overflow-y: auto;
  height: 310px;
  /* border: 1px solid #95beb5; */
}

.nocodelink {
  width: 145px;
}

.productmanagementlink {
  width: 194px;
}

.marketinglink {
  width: 118px;
}

.cybersecuritylink {
  width: 142px;
}

.datasciencelink {
  width: 134px;
}

.productdesignlink {
  width: 147px;
}

.softwarelink {
  width: 190px;
}

@media (min-width: 297px) and (max-width: 567px) {
  .coursetttab {
    margin: 10px;
    padding: 10px;
    /* border: 1px solid #95beb5; */
    overflow-y: auto;
    height: 400px;
  }

  .companylogo {
    margin-left: 5px; 
  }

  .coursescolorbox {
    margin-top: 7px;
    right: 0.5%;
    position: absolute;
    z-index: 999;
    width: 100%;
    /* height: 500px; */
    background-color: #eef7f0;
    /* border: 1px solid #95beb5; */
    border-radius: 10px;
  }

  .firstheader {
    margin-left: 20px;
    height: 15px;
    width: 22px;
    border: 1px solid #000000;
    border-radius: 3px;
    display: inline;
  }

  .coursesNav {
    margin-top: 10px;
  }

  /* .coursescolorbox { position: absolute; top: 40%; right: 40%; width: 240px; height: 240px; background-color: #e3f8e7; border: 1px solid #95beb5; border-radius: 10px } */
  .nocodelink {
    width: fit-content;
  }

  .productmanagementlink {
    width: fit-content;
  }

  .marketinglink {
    width: fit-content;
  }

  .cybersecuritylink {
    width: fit-content;
  }

  .datasciencelink {
    width: fit-content;
  }

  .productdesignlink {
    width: fit-content;
  }

  .softwarelink {
    width: fit-content;
  }
}

.navbar-nav .no-arrow .dropdown-toggle::after {
  display: none !important;
}

@media (min-width: 100px) and (max-width: 293px) {
  .nocodelink {
    width: fit-content;
  }

  .companylogo {
    width: 80px; 
    height: 38px;
    cursor: pointer;
    margin-left: 5px; 
  }

  .productmanagementlink {
    width: fit-content;
  }

  .marketinglink {
    width: fit-content;
  }

  .cybersecuritylink {
    width: fit-content;
  }

  .datasciencelink {
    width: fit-content;
  }

  .productdesignlink {
    width: fit-content;
  }

  .softwarelink {
    width: fit-content;
  }

  .coursetttab {
    margin: 10px;
    padding: 10px;
    /* border: 1px solid #95beb5; */
    overflow-y: auto;
    height: 400px;
  }

  .coursescolorbox {
    margin-top: 7px;
    right: 0.5%;
    position: absolute;
    z-index: 77;
    width: 100%;
    /* height: 500px; */
    background-color: #eef7f0;
    /* border: 1px solid #95beb5; */
    border-radius: 10px;
  }

  .companylogo {
    width: 116px;
    height: 38px;
    cursor: pointer;
    margin-left: 60px;
  }

  .secondheaders {
    background-color: #ffffff;
    position: fixed;
    top: 62px;
    width: 100%;
    z-index: 101;
  }

  .coursesNav {
    margin-top: 10px;
  }
}

@media (min-width: 570px) and (max-width: 990px) {
  .nocodelink {
    width: 380px;
  }

  .productmanagementlink {
    width: 380px;
  }

  .marketinglink {
    width: 380px;
  }

  .cybersecuritylink {
    width: 380px;
  }

  .datasciencelink {
    width: 380px;
  }

  .productdesignlink {
    width: 380px;
  }

  .softwarelink {
    width: 419px;
  }

  .coursesNav {
    margin-top: 10px;
  }

  .coursetttab {
    margin: 10px;
    padding: 10px;
    /* border: 1px solid #95beb5; */
    overflow-y: auto;
    height: 400px;
  }

  .coursescolorbox {
    margin-top: 7px;
    right: 0.5%;
    position: absolute;
    z-index: 77;
    width: 100%;
    /* height: 500px; */
    background-color: #eef7f0;
    /* border: 1px solid #95beb5; */
    border-radius: 10px;
  }
}

@media (min-width: 1000px) and (max-width: 1150px) {
  .nocodelink {
    width: 145px;
  }

  .productmanagementlink {
    width: 194px;
  }

  .marketinglink {
    width: 118px;
  }

  .cybersecuritylink {
    width: 142px;
  }

  .datasciencelink {
    width: 134px;
  }

  .productdesignlink {
    width: 147px;
  }

  .softwarelink {
    width: 190px;
  }

  /* your css rules for ipad portrait */
  .coursescolorbox {
    margin-top: 7px;
    right: 20%;
    position: absolute;
    z-index: 77;
    width: 700px;
    /* height: 500px; */
    background-color: #eef7f0;
    /* border: 1px solid #95beb5; */
    border-radius: 10px;
  }

  .coursetttab {
    margin: 10px;
    padding: 10px;
    /* border: 1px solid #95beb5; */
  }

  .secondheaders {
    background-color: #ffffff;
    position: fixed;
    top: 100px;
    width: 100%;
    z-index: 101;
  }

  .nav-links2 {
    padding-left: 0px;
    margin-left: 0px;
    padding-right: 0px;
    margin-right: 0px;
    width: 30px;
  }

  .lastcon {
    float: right;
    margin-right: 10px;
  }
}

@media (max-width:991px) {
  .headeradj {
    margin-left: 0px;
  }
}

@media (min-width:1000px) and (max-width:1150px) {
  .secondheaders {
    margin-top: 80px;
  }
}

.secondheaders .flex {
  justify-content: flex-end;
  text-align: right;
  gap: 20px;
}

@media (max-width: 768px) {
  .secondheaders .flex {
    justify-content: center;
    text-align: center;
    flex-wrap: wrap;
    gap: 10px;
  }
}




@media (min-width:1670px) {
  .coursescolorbox {
    right: 45%;
  }
}

@media (min-width:2150px) {
  .coursescolorbox {
    right: 65%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D,yBAAyB;AACzB;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;WACS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,0KAA0K;EAC1K;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;AACF;;;;;AAKA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* .login { /* border: 2px solid #367e3e; color: #047e35; */\n/* border-radius: 10px; */\n.header {\n  opacity: 1;\n  transition: opacity ease-in;\n}\n\n.hidden {\n  opacity: 0;\n  transform: opacity 0.3s ease-out;\n}\n\n.joinforbtn {\n  background-color: #158b86;\n  display: inline;\n  margin-left: 10px;\n  color: #ffffff;\n}\n\n.joinforbtn:hover {\n  background-color: #16918a;\n  display: inline;\n  margin-left: 10px;\n  color: #ffffff;\n}\n\n.companylogo {\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.header-container {\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n  background: url(\"/public/images/header-img.png\");\n  background-size: cover;\n}\n\n.header-container h1 {\n  font-weight: 700;\n  text-align: center;\n  font-size: 3rem;\n}\n\n.secondheaders {\n  background-color: #ffffff;\n  /* position: fixed; */\n  top: 73px;\n  width: 100%;\n  z-index: 101;\n}\n\n.firstheader {\n  margin-left: 25px;\n  height: 15px;\n  width: 22px;\n  border: 1px solid #000000;\n  border-radius: 3px;\n  display: inline;\n}\n\n.lastcon {\n  float: right;\n  margin-right: 10px;\n}\n\n.dropdown-toggle::after {\n  color: #000000;\n}\n\n.nav-item .dropdown-menu {\n  background: #e3f8e7;\n}\n\n.nav-item .dropdown-item {\n  color: #000000;\n}\n\n.nav-item .dropdown-item:hover {\n  background: #f0ad4e;\n  color: #ffffff;\n}\n\n.activate {\n  border-bottom: 2px solid green;\n}\n\n.nav-links {\n  transition: 0.3s;\n  margin-top: 2px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  font-family: \"Josefin Sans\",\n    cursive;\n}\n\n.nav-links:hover {\n  border-bottom: 2px solid green;\n}\n\n.nav-links:focus {\n  border-bottom: 2px solid green;\n}\n\n.nav-links2 {\n  transition: 0.3s;\n  margin-top: 2px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.nav-links2:hover {\n  border-bottom: 2px solid green;\n}\n\n.nav-links2:focus {\n  border-bottom: 2px solid green;\n}\n\n.nav-links4 {\n  transition: 0.3s;\n  margin-top: 2px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  color: #0f6863;\n}\n\n.nav-links4:hover {\n  color: #0f6863;\n  border-bottom: 2px solid #076460;\n}\n\n.nav-links4:focus {\n  color: #0f6863;\n  border-bottom: 2px solid #076460;\n}\n\n.nav-links23 {\n  transition: 0.3s;\n  margin-top: -5px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  /* margin-left: 5px; margin-right: 5px; */\n}\n\n.nav-links23:hover {\n  border-bottom: 2px solid green;\n}\n\n.nav-links23:focus {\n  border-bottom: 2px solid green;\n}\n\n.nav-links3 {\n  transition: 0.3s;\n  margin-top: 10px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.navbar_toggle_icon {\n  background-color: darkgreen;\n  color: red;\n}\n\n.socialmed {\n  color: #0c572b;\n}\n\n.socialmed2 {\n  color: #0c572b;\n  cursor: pointer;\n}\n\n.showprofilebox {\n  display: block;\n}\n\n.hideprofilebox {\n  display: none;\n}\n\n.coursesNav {\n  margin-top: 7%;\n}\n\n.coursescolorbox {\n  margin-top: 7px;\n  right: 30%;\n  position: absolute;\n  z-index: 77;\n  width: 900px;\n  /* max-width: 90vw; */\n  /* height: 500px; */\n  background-color: #e3f8e7;\n  /* border: 1px solid #95beb5; */\n  border-radius: 10px;\n}\n\n.dropdown-menu {\n  background: #f2ffd8;\n}\n\n.servicesColorbox {\n  margin-top: 7px;\n  left: 10%;\n  /* right: 0%; */\n  position: absolute;\n  z-index: 77;\n  width: 250px;\n  /* height: 500px; */\n  background-color: #e3f8e7;\n  /* border: 1px solid #95beb5; */\n  border-radius: 10px;\n}\n\n.coursetttab {\n  margin: 10px;\n  padding: 10px;\n  overflow-y: auto;\n  height: 470px;\n  /* border: 1px solid #95beb5; */\n}\n\n.servicestttab {\n  /* margin: 10px; */\n  /* padding: 10px; */\n  overflow-y: auto;\n  height: 310px;\n  /* border: 1px solid #95beb5; */\n}\n\n.nocodelink {\n  width: 145px;\n}\n\n.productmanagementlink {\n  width: 194px;\n}\n\n.marketinglink {\n  width: 118px;\n}\n\n.cybersecuritylink {\n  width: 142px;\n}\n\n.datasciencelink {\n  width: 134px;\n}\n\n.productdesignlink {\n  width: 147px;\n}\n\n.softwarelink {\n  width: 190px;\n}\n\n@media (min-width: 297px) and (max-width: 567px) {\n  .coursetttab {\n    margin: 10px;\n    padding: 10px;\n    /* border: 1px solid #95beb5; */\n    overflow-y: auto;\n    height: 400px;\n  }\n\n  .companylogo {\n    margin-left: 5px; \n  }\n\n  .coursescolorbox {\n    margin-top: 7px;\n    right: 0.5%;\n    position: absolute;\n    z-index: 999;\n    width: 100%;\n    /* height: 500px; */\n    background-color: #eef7f0;\n    /* border: 1px solid #95beb5; */\n    border-radius: 10px;\n  }\n\n  .firstheader {\n    margin-left: 20px;\n    height: 15px;\n    width: 22px;\n    border: 1px solid #000000;\n    border-radius: 3px;\n    display: inline;\n  }\n\n  .coursesNav {\n    margin-top: 10px;\n  }\n\n  /* .coursescolorbox { position: absolute; top: 40%; right: 40%; width: 240px; height: 240px; background-color: #e3f8e7; border: 1px solid #95beb5; border-radius: 10px } */\n  .nocodelink {\n    width: fit-content;\n  }\n\n  .productmanagementlink {\n    width: fit-content;\n  }\n\n  .marketinglink {\n    width: fit-content;\n  }\n\n  .cybersecuritylink {\n    width: fit-content;\n  }\n\n  .datasciencelink {\n    width: fit-content;\n  }\n\n  .productdesignlink {\n    width: fit-content;\n  }\n\n  .softwarelink {\n    width: fit-content;\n  }\n}\n\n.navbar-nav .no-arrow .dropdown-toggle::after {\n  display: none !important;\n}\n\n@media (min-width: 100px) and (max-width: 293px) {\n  .nocodelink {\n    width: fit-content;\n  }\n\n  .companylogo {\n    width: 80px; \n    height: 38px;\n    cursor: pointer;\n    margin-left: 5px; \n  }\n\n  .productmanagementlink {\n    width: fit-content;\n  }\n\n  .marketinglink {\n    width: fit-content;\n  }\n\n  .cybersecuritylink {\n    width: fit-content;\n  }\n\n  .datasciencelink {\n    width: fit-content;\n  }\n\n  .productdesignlink {\n    width: fit-content;\n  }\n\n  .softwarelink {\n    width: fit-content;\n  }\n\n  .coursetttab {\n    margin: 10px;\n    padding: 10px;\n    /* border: 1px solid #95beb5; */\n    overflow-y: auto;\n    height: 400px;\n  }\n\n  .coursescolorbox {\n    margin-top: 7px;\n    right: 0.5%;\n    position: absolute;\n    z-index: 77;\n    width: 100%;\n    /* height: 500px; */\n    background-color: #eef7f0;\n    /* border: 1px solid #95beb5; */\n    border-radius: 10px;\n  }\n\n  .companylogo {\n    width: 116px;\n    height: 38px;\n    cursor: pointer;\n    margin-left: 60px;\n  }\n\n  .secondheaders {\n    background-color: #ffffff;\n    position: fixed;\n    top: 62px;\n    width: 100%;\n    z-index: 101;\n  }\n\n  .coursesNav {\n    margin-top: 10px;\n  }\n}\n\n@media (min-width: 570px) and (max-width: 990px) {\n  .nocodelink {\n    width: 380px;\n  }\n\n  .productmanagementlink {\n    width: 380px;\n  }\n\n  .marketinglink {\n    width: 380px;\n  }\n\n  .cybersecuritylink {\n    width: 380px;\n  }\n\n  .datasciencelink {\n    width: 380px;\n  }\n\n  .productdesignlink {\n    width: 380px;\n  }\n\n  .softwarelink {\n    width: 419px;\n  }\n\n  .coursesNav {\n    margin-top: 10px;\n  }\n\n  .coursetttab {\n    margin: 10px;\n    padding: 10px;\n    /* border: 1px solid #95beb5; */\n    overflow-y: auto;\n    height: 400px;\n  }\n\n  .coursescolorbox {\n    margin-top: 7px;\n    right: 0.5%;\n    position: absolute;\n    z-index: 77;\n    width: 100%;\n    /* height: 500px; */\n    background-color: #eef7f0;\n    /* border: 1px solid #95beb5; */\n    border-radius: 10px;\n  }\n}\n\n@media (min-width: 1000px) and (max-width: 1150px) {\n  .nocodelink {\n    width: 145px;\n  }\n\n  .productmanagementlink {\n    width: 194px;\n  }\n\n  .marketinglink {\n    width: 118px;\n  }\n\n  .cybersecuritylink {\n    width: 142px;\n  }\n\n  .datasciencelink {\n    width: 134px;\n  }\n\n  .productdesignlink {\n    width: 147px;\n  }\n\n  .softwarelink {\n    width: 190px;\n  }\n\n  /* your css rules for ipad portrait */\n  .coursescolorbox {\n    margin-top: 7px;\n    right: 20%;\n    position: absolute;\n    z-index: 77;\n    width: 700px;\n    /* height: 500px; */\n    background-color: #eef7f0;\n    /* border: 1px solid #95beb5; */\n    border-radius: 10px;\n  }\n\n  .coursetttab {\n    margin: 10px;\n    padding: 10px;\n    /* border: 1px solid #95beb5; */\n  }\n\n  .secondheaders {\n    background-color: #ffffff;\n    position: fixed;\n    top: 100px;\n    width: 100%;\n    z-index: 101;\n  }\n\n  .nav-links2 {\n    padding-left: 0px;\n    margin-left: 0px;\n    padding-right: 0px;\n    margin-right: 0px;\n    width: 30px;\n  }\n\n  .lastcon {\n    float: right;\n    margin-right: 10px;\n  }\n}\n\n@media (max-width:991px) {\n  .headeradj {\n    margin-left: 0px;\n  }\n}\n\n@media (min-width:1000px) and (max-width:1150px) {\n  .secondheaders {\n    margin-top: 80px;\n  }\n}\n\n.secondheaders .flex {\n  justify-content: flex-end;\n  text-align: right;\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .secondheaders .flex {\n    justify-content: center;\n    text-align: center;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n}\n\n\n\n\n@media (min-width:1670px) {\n  .coursescolorbox {\n    right: 45%;\n  }\n}\n\n@media (min-width:2150px) {\n  .coursescolorbox {\n    right: 65%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
